<template>
  <div class="chat">
    <div class="row">
      <ChatButton v-show="showChatButton" id="chat-button" v-on:click.native="onClickBotButton" :style="{bottom: '200px'}"></ChatButton>
    </div>
    <div class="row">
      <ChatBubble :bubbleText="bubbleCta" :showBubble="showBubble" v-on:click.native="showBubble = !showBubble"></ChatBubble>
    </div>
    <div class="chat-window" v-show="showChatbot">
      <div class="containerBox" id="containerBox" :style="{overflowY : showFullChat ? 'hidden' : 'auto', overflowX : 'hidden'}">
        <div class="wrapper" v-show="showChatbot">
          <div class="header">
            <img class="botIcon" src="../assets/VirtualAssistant_Heading-01.png" width="167" height="20">
            <CloseButton v-model="showChatbot" v-on:click.native="onClickButton"></CloseButton>
          </div>
          <div>
            <div class="title" v-show="showFullChat">Send yourself a copy of this conversation</div>
            <button class="submitButton btn btn-primary" v-show="showFullChat" v-on:click="createEmail()">Send</button>
          </div>
          <hr>
          <div class="page-content" ref="scrollBox" :style="{overflowY: showFullChat ? 'scroll' : 'initial', overflowX: showFullChat ? 'hidden' : 'initial'}">
            <IntroForm v-if="showIntro" @submitted="onSubmit" :introText="introText"></IntroForm>
            <div class="container no-margin removePadding" v-if="showFullChat" ref="chatHolder">
              <transition-group name="message-list" tag="div" v-bind:css="false" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter" appear>
                <li ref="message" v-for="m in messages" v-bind:key="m.priority" v-bind:data-index="m.priority">
                  <div v-if="m.showNameTimestamp" :key="m.index" :class="{'userBlurb': m.type == 'user', 'botBlurb': m.type == 'bot', 'buttonBlurb': m.type == 'button'}">
                    {{ m.messageName }} {{ m.time }}
                  </div>
                  <div :class="{'userMessage': m.type == 'user', 'botMessage': m.type == 'bot', 'buttonMessage': m.type == 'button'}">
                    <transition name="fade" mode="out-in">
                      <div v-if="!m.showDots">
                        <p :class="{'msgUser': m.type == 'user', 'msgBot': m.type == 'bot', 'msgButton': m.type == 'button'}" v-html="m.message"></p>
                        <div class="buttonHolder" v-for="choice in m.choices" v-bind:key="choice.index">
                          <button class="choice" v-on:click="sendChoice(choice.choiceContent)">{{ choice.choiceContent }}</button>
                        </div>
                      </div>
                      <div v-else class="dotHolder">
                        <div class="dot1"></div>
                        <div class="dot2"></div>
                        <div class="dot3"></div>
                      </div>
                    </transition>
                  </div>
                </li>
              </transition-group>
            </div>
          </div>
          <div class="row" v-if="showFullChat">
            <!--div class="nopadding">
              <button class="staticButton">Skip Question</button>
            </div-->
            <div class="nopadding">
              <button class="staticButton col-md-12 text-left">Book now</button>
            </div>
            <!--div class="col-md-4 nopadding">
              <button class="staticButton">{{ this.firstName }}'s Profile</button>
            </div-->
            <!--div class="profileBlurb" v-show="showProfileBlurb" v-on:click="showProfileBlurb = !showProfileBlurb">I auto generate a profile for you as you share information! Click here to view or edit your profile.</div-->
          </div>
          <div class="inputWithImage" v-if="showFullChat">
            <input class="userInput" v-bind:disabled="disabled" v-model="query" @keyup.enter="submitMessage()" placeholder='Type here...' type="text" maxlength="256">
            <img :src="arrow" @mouseover="arrow=require('../assets/Arrow_hover.png')" @mouseleave="arrow=require('../assets/Arrow.png')" @click="submitMessage()" class="arrowButton" width="25" height="25"/>
          </div>
          <div class="footer" v-if="showFullChat">
            <p class="footerBlurb">
              <a href="https://www.leadmanaging.com/privacy-policy" target="_blank" class="link">{{ footerBlurb }}</a>
            </p>
            <div class="poweredBlurb">
              <a href="http://www.leadmanaging.com" target="_blank">
                <img src="../assets/PVChatbotFooter.png" width="150" height="42"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatButton from './ChatButton.vue'
import ChatBubble from './ChatBubble.vue'
import CloseButton from './CloseButton.vue'
import IntroForm from './IntroForm.vue'
import uuidv4 from 'uuid/v4'
import axios from 'axios'
import moment from 'moment'
import Velocity from 'velocity-animate'

const sessionId = uuidv4()
const apiUrl = '/api/'
const language = 'en-US'

export default {
  name: 'LandingPage',

  components: {
    'ChatButton': ChatButton,
    'ChatBubble': ChatBubble,
    'CloseButton': CloseButton,
    'IntroForm': IntroForm
  },

  data () {
    return {
      showChatbot: false,
      showFullChat: false,
      showChatButton: true,
      showIntro: true,
      showBubble: true,
      title: 'ChatManaging',
      introText: 'Hey! Please let me know your name and email, and I would be happy to have a quick chat. 😃 ',
      subject: 'Your ChatManaging conversation',
      close: 'X',
      firstName: 'N/A',
      lastName: 'N/A',
      email: 'N/A',
      staffEmail: '',
      bookNow: '',
      messages: [],
      query: '',
      saveQuery: '',
      buttonReply: 'You chose: ',
      showMessage: true,
      currentTime: null,
      arrow: require('../assets/Arrow.png'),
      botName: 'ChatManaging',
      footerBlurb: 'Terms of Service',
      poweredBy: 'Powered by',
      delayFactorOne: 500,
      delayFactorTwo: 7,
      highestPriority: 0,
      priorityOne: 1,
      priorityTwo: 6,
      priorityThree: 11,
      countArray: 0,
      client: null,
      building: null,
      showProfileBlurb: true,
      bubbleCta: 'Hi! If you\'re interested in renting with us, have questions about availability, or want to book a viewing, I\'m happy to help! 😊',
      phone: 'N/A',
      unitType: 'N/A',
      moveIn: 'N/A',
      budget: 'N/A',
      apptDate: 'N/A'
    }
  },


  created () {
    window.addEventListener('beforeunload', this.handler)
  },

  methods: {
    onClickBotButton (event) {
      this.showChatbot = !this.showChatbot
      this.showChatButton = false

      if (this.showBubble === true) {
        this.showBubble = !this.showBubble
      }
    },

    onClickButton (event) {
      this.showChatbot = !this.showChatbot
      if (this.showChatButton === false) {
        this.showChatButton = !this.showChatButton
      }
    },

    handler: function handler(event) {
      this.sendNotification()
    },

    sendNotification () {
      if (this.staffEmail === '') {
        return
      }

      var headers = {
        'Content-Type': 'application/json'
      }

      // We are going to create the "log" of messages, plus timestamp and who wrote the message
      let i = 0
      let j = 0
      let log = ''
      for (i = 0; i < this.messages.length; i++) {
        log = log + this.messages[i].messageName + ' at  ' + this.messages[i].time + '<br>' + this.messages[i].message + '<br>'

        for (j = 0; j < this.messages[i].choices.length; j++) {
          log = log + '- ' + this.messages[i].choices[j].choiceContent + '<br>'
        }
        log = log + '<hr><br>'
      }

      /*let callParameterApi = apiUrl + 'detect?' + 'sessionId=' + sessionId + '&langCode=' + language + '&query=' + this.grabProfile

      axios.get(callParameterApi)
        .then((response) => {
          // Piece together the URL
          let callApi = apiUrl + 'sendescalation?firstName=' + this.firstName + '&lastName=' + this.lastName + '&email=' + this.email + '&staffemail=' + this.staffEmail

          if (response.data.queryResult.parameters.fields.PhoneNumber.stringValue != '') {
            callApi = callApi + '&phone=' + response.data.queryResult.parameters.fields.PhoneNumber.stringValue
          }

          else {
            callApi = callApi + '&phone=N/A'
          }

          if (response.data.queryResult.parameters.fields.UnitType.listValue.values[0].stringValue != '') {
            callApi = callApi + '&unittype=' + response.data.queryResult.parameters.fields.UnitType.listValue.values[0].stringValue
          }

          else {
            callApi = callApi + '&unittype=' + 'N/A'
          }

          if (response.data.queryResult.parameters.fields.date.stringValue != '') {
            callApi = callApi + '&movein=' + response.data.queryResult.parameters.fields.date.stringValue.split("T")[0]
          }

          else if (response.data.queryResult.parameters.fields["date-period"].structValue.fields.startDate.stringValue != '') {
            callApi = callApi + '&movein=' + response.data.queryResult.parameters.fields["date-period"].structValue.fields.startDate.stringValue.slice(0, 7)
          }

          else if (response.data.queryResult.parameters.fields.CheckMoveInASAP.stringValue != '') {
            callApi = callApi + '&movein=' + 'ASAP'
          }

          if (response.data.queryResult.parameters.fields.number.numberValue != '') {
            callApi = callApi + '&budget=' + response.data.queryResult.parameters.fields.number.numberValue
          }

          callApi = callApi + '&apptdate=' + this.apptDate + '&log=' + log
          return axios.get(callApi)
        })
        .then((response) => {
          console.log('response -----> ', response)
        })*/

      let callApi = apiUrl + 'sendescalation?firstName=' + this.firstName + '&lastName=' + this.lastName + '&email=' + this.email + '&staffemail=' + this.staffEmail + '&phone=' + this.phone + '&unittype=' + this.unitType + '&movein=' + this.moveIn + '&budget=' + this.budget + '&apptdate=' + this.apptDate

      axios.get(callApi)
        .then(response => {
          console.log('response ------> ', response)
        }).catch(function (error) {
          console.log(error)
        })
    },

    createEmail () {
      var headers = {
        'Authorization': process.env.VUE_APP_SENDGRID_API_KEY,
        'Content-Type': 'application/json'
      }

      // We are going to create the "log" of messages, plus timestamp and who wrote the message
      let i = 0
      let j = 0
      let log = ''
      for (i = 0; i < this.messages.length; i++) {
        log = log + this.messages[i].messageName + ' at  ' + this.messages[i].time + '<br>' + this.messages[i].message + '<br>'

        for (j = 0; j < this.messages[i].choices.length; j++) {
          log = log + '- ' + this.messages[i].choices[j].choiceContent + '<br>'
        }
        log = log + '<hr><br>'
      }

      let callApi = apiUrl + 'sendmail?firstName=' + this.firstName + '&lastName=' + this.lastName + '&subject=' + this.subject + '&email=' + this.email + '&building=' + this.$route.query.building + '&log=' + log

      axios.get(callApi, {headers: headers})
        .then(response => {
          console.log('response ------> ', response)
        }).catch(function (error) {
          console.log(error)
        })

      this.currentTime = moment().format('LT')
      this.addToMessages(this.firstName, this.currentTime, 'Email sent successfully', 'button', false, true, false, this.highestPriority, [])
    },

    getApiResults (callApi) {
      axios.get(callApi).then(response => {
        response = response.data
        let numReplies = response.queryResult.fulfillmentMessages.length
        let i = 0
        let count = 1
        let holdChoices = []

        if (response.queryResult.fulfillmentText.includes('Alright, one of our representatives will') === true) {
          this.sendEscalation()
        }

        // If the response is from a webhook, we will have to break it up into different messages
        // First, split up the messages based on the string "(msgbreak)", which is the designated delimiter
        if (response.queryResult.webhookSource === 'webhook') {
          var arrayOfSplitReplies = response.queryResult.fulfillmentMessages[0].text.text[0].split('(msgbreak)')

          // Now push each of these split messages into messages array
          var numSplitReplies = arrayOfSplitReplies.length
          for (i = 0; i < numSplitReplies; i++) {
            // While we are considering each message, we must check for any buttons and if they exist, further break it into clickable messages
            var containsButtons = arrayOfSplitReplies[i].includes('(spacebreak)')

            // If there were actually some buttons in this message...
            if (containsButtons) {
              // ...push each one into the choices array.
              // First split by spacebreak
              var splitIntoTwo = arrayOfSplitReplies[i].split('(spacebreak)')
              var buttons = splitIntoTwo[1].split('(btnbreak)')
              for (i = 0; i < buttons.length; i++) {
                // As long as the string is not empty
                if (buttons[i] !== '') {
                  holdChoices.push({ choiceContent: buttons[i] })
                }
              }
              let flagNameTimestamp = true
              this.addToMessages(this.botName, this.currentTime, splitIntoTwo[0], 'bot', false, flagNameTimestamp, true, count, holdChoices)
              count = count + 2
            } else {
              this.currentTime = moment().format('LT')
              let flagNameTimestamp = false

              if (i === 0) {
                flagNameTimestamp = true
              }

              this.addToMessages(this.botName, this.currentTime, arrayOfSplitReplies[i], 'bot', false, flagNameTimestamp, true, count, [])
              count = count + 2
            }
          }
        } else {
          // If it's not from a webhook, the replies will already be broken up. But we have to check for buttons.
          for (i = 0; i < numReplies; i++) {
            this.currentTime = moment().format('LT')
            let flagNameTimestamp = false

            if (i === 0) {
              flagNameTimestamp = true
            }

            this.addToMessages(this.botName, this.currentTime, response.queryResult.fulfillmentMessages[i].text.text[0], 'bot', false, flagNameTimestamp, true, count, [])
            count = count + 2
          }
        }
      }).catch(function (error) {
        console.log(error)
      })
    },

    sendEscalation () {
      if (this.staffEmail === '') {
        return
      }

      var headers = {
        'Content-Type': 'application/json'
      }

      // We are going to create the "log" of messages, plus timestamp and who wrote the message
      let i = 0
      let j = 0
      let log = ''
      for (i = 0; i < this.messages.length; i++) {
        log = log + this.messages[i].messageName + ' at  ' + this.messages[i].time + '<br>' + this.messages[i].message + '<br>'

        for (j = 0; j < this.messages[i].choices.length; j++) {
          log = log + '- ' + this.messages[i].choices[j].choiceContent + '<br>'
        }
        log = log + '<hr><br>'
      }

      let callParameterApi = apiUrl + 'detect?' + 'sessionId=' + sessionId + '&langCode=' + language + '&query=' + this.grabProfile

      axios.get(callParameterApi)
        .then((response) => {
          // Piece together the URL
          let callApi = apiUrl + 'sendescalation?firstName=' + this.firstName + '&lastName=' + this.lastName + '&email=' + this.email + '&staffemail=' + this.staffEmail

          if (response.data.queryResult.parameters.fields.PhoneNumber.stringValue != '') {
            callApi = callApi + '&phone=' + response.data.queryResult.parameters.fields.PhoneNumber.stringValue
          }

          else {
            callApi = callApi + '&phone=N/A'
          }

          if (response.data.queryResult.parameters.fields.UnitType.listValue.values[0].stringValue != '') {
            callApi = callApi + '&unittype=' + response.data.queryResult.parameters.fields.UnitType.listValue.values[0].stringValue
          }

          else {
            callApi = callApi + '&unittype=' + 'N/A'
          }

          if (response.data.queryResult.parameters.fields.date.stringValue != '') {
            callApi = callApi + '&movein=' + response.data.queryResult.parameters.fields.date.stringValue.split("T")[0]
          }

          else if (response.data.queryResult.parameters.fields["date-period"].structValue.fields.startDate.stringValue != '') {
            callApi = callApi + '&movein=' + response.data.queryResult.parameters.fields["date-period"].structValue.fields.startDate.stringValue.slice(0, 7)
          }

          else if (response.data.queryResult.parameters.fields.CheckMoveInASAP.stringValue != '') {
            callApi = callApi + '&movein=' + 'ASAP'
          }

          if (response.data.queryResult.parameters.fields.number.numberValue != '') {
            callApi = callApi + '&budget=' + response.data.queryResult.parameters.fields.number.numberValue
          }

          callApi = callApi + '&apptdate=' + this.apptDate + '&log=' + log
          return axios.get(callApi)
        })
        .then((response) => {
          console.log('response -----> ', response)
        })
    },

    addToMessages (inputName, inputTime, inputMessage, inputType, inputCheckmark, inputTimestamp, inputDots, inputPriority, inputChoices) {
      this.messages.push(
        {
          messageName: inputName,
          time: inputTime,
          message: inputMessage,
          type: inputType,
          showSecondCheckmark: inputCheckmark,
          showNameTimestamp: inputTimestamp,
          showDots: inputDots,
          priority: inputPriority,
          choices: inputChoices
        })

      this.scrollToBottom()
    },

    beforeEnter (el) {
      el.style.opacity = 0
      el.style.height = 0
    },

    enter (el, done) {
      var delay = el.dataset.index * this.delayFactorOne
      var animationLength = el.innerHTML.length * this.delayFactorTwo

      setTimeout(function () {
        Velocity(
          el,
          { opacity: 1, height: '100%' },
          { duration: animationLength, easing: [ 0.17, 0.27, 0.04, 0.88 ], complete: done })
      }, delay)
    },

    afterEnter (el) {
      this.messages[this.countArray].showDots = false
      this.countArray++
    },

    onSubmit (chatFlag, introFlag, firstName, lastName, email) {
      // Save the contact details
      this.showFullChat = chatFlag
      this.showIntro = introFlag
      this.firstName = firstName
      this.lastName = lastName
      this.email = email
      this.showChatButton = false
      this.currentTime = moment().format('LT')

      this.addToMessages(this.firstName, this.currentTime, 'Provided contact info', 'button', false, true, false, this.highestPriority, [])

      // Send message to the chatbot in order to get a reply with bedroom types. Note we are sending the name of the config file it will read from, then (break), then the building name
      let callApi = apiUrl + 'detect?' + 'sessionId=' + sessionId + '&langCode=' + language + '&query=' + this.client + '(break)' + this.building

      // Call the api with this url
      this.getApiResults(callApi)
    },

    scrollToBottom () {
      this.$refs.scrollBox.scrollTop = this.$refs.scrollBox.scrollHeight
    },

    submitMessage () {
      this.currentTime = moment().format('LT')

      // Save the user's message(s) into messages
      this.addToMessages(this.firstName, this.currentTime, this.query, 'user', false, true, false, this.highestPriority, [])

      this.saveQuery = this.query
      this.query = ''

      // setTimeout(function () {
      //   this.messages[this.messages.length - 1].showSecondCheckmark = true
      // }.bind(this), this.delayFactor)

      let callApi = apiUrl + 'detect?' + 'sessionId=' + sessionId + '&langCode=' + language + '&query=' + this.saveQuery

      // Call the api with the url
      this.getApiResults(callApi)
    },

    sendChoice (choiceContent) {
      this.currentTime = moment().format('LT')
      let fullButtonReply = this.buttonReply + choiceContent
      // The user has clicked on a button. We must append this to our messages list as a user's message.
      this.addToMessages(this.firstName, this.currentTime, fullButtonReply, 'button', false, true, false, this.highestPriority, [])

      // Now create the api url and call get
      let callApi = apiUrl + 'detect?' + 'sessionId=' + sessionId + '&langCode=' + language + '&query=' + choiceContent
      this.getApiResults(callApi)
    },

    setVariables () {
      if (this.$route.query.client === 'sandbox') {
        this.staffEmail = 'lead-snb-100277@leadmanaging.com'
        this.bookNow = 'https://sandbox.leadmanaging.com/application/controllers/booking.php?r=zdckQUExMDAzNTc='
      } else if (this.$route.query.client === 'gwl') {
        this.staffEmail = ''
        this.bookNow = ''
      } else if (this.$route.query.client === 'kelsongroup') {
        this.staffEmail = ''
        this.bookNow = ''
      }
    }
  },

  mounted () {
    this.scrollToBottom()
    this.client = this.$route.query.client + '.csv'
    this.building = this.$route.query.building
    this.setVariables()

    parent.postMessage({'event': 'chatbot-resize', 'data': 60}, '*')
  },

  updated () {
    this.$nextTick(this.scrollToBottom())
  }
}
</script>

<style scoped>
.chat {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
}

.chat-window {
  position: absolute;
  top: 20px;
  right: 20px;
  bottom: 40px;
  left: 20px;
  display: block;
  float: right;
}

.wrapper {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
}

.removePadding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.containerBox {
  z-index: 1;
  position: relative;
  overflow: hidden;
  display: block;
  float: right;
  -webkit-filter: drop-shadow(0px 0px 5px #d7d5d5);
  filter: drop-shadow(0px 0px 5px #d7d5d5);
  background-color: #FFFFFF;
  padding: 0px 15px;
  border-radius: 5px;
  padding-bottom: 15px;
  width: 100%;
  height: 100%;
}

body {
  overflow: hidden;
  background: transparent !important;
  background-color: transparent !important;
}

.no-margin {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.header {
  position: relative;
  overflow: hidden;
  color: #4391CF;
  font-family: 'Bree Serif', serif;
  font-size: 22px;
}

.space {
  padding-top: 10px;
}

hr {
  border: 1px solid #f7f6f6;
  width: 100%;
  margin-bottom: 0;
  margin-top: 5px;
}

.botIcon {
  margin-top: 10px;
}

.title {
  font-size: 10px;
  font-family: "Arial";
  color: #4391CF;
  margin-top: 10px;
  display: inline-block;
}

.page-content {
  float: left;
  width: 100%;
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
  font-family: "Arial";
  font-size: 12px;
  height: calc(100% - 215px);
}

.inputWithImage {
  position: absolute;
  bottom: 60px;
  width: 100%;
}

.arrowButton {
  position: absolute;
  cursor: pointer;
  right: 40px;
  top: 10px;
}

.stickyFooter {
  flex: 0 0 auto;
}

.submitButton {
  padding-left: 20px;
  padding-right: 20px;
  background-color: #4391CF;
  border: none;
  font-size: 12px;
  margin-bottom: 5px;
  margin-top: 5px;
  display: inline-block;
  margin-left: 10px;
  margin-right: 20px;
}

.submitButton:hover {
  background-color: #3984b7;
}

.nopadding {
  padding: 8px 5px 8px 15px !important;
}

.staticButton {
  width: 100%;
  background-color: #FFFFFF;
  color: #4391CF;
  font-size: 12px;
  border: 1.5px #4391CF solid;
  cursor: pointer;
  border-radius: .25rem;
  padding-top: 5px;
  padding-bottom: 5px;
  font-weight: bold;
}

.profileBlurb {
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: 0 0 6px #B2B2B2;
  display: inline-block;
  padding: 10px 18px;
  position: absolute;
  vertical-align: top;
  margin: 20px 10px;
  font-size: 12px;
  right: 15px;
  bottom: 140px;
  width: 150px;
  animation: fadeIn 6s linear;
}

.profileBlurb::before {
  background-color: #FFFFFF;
  content: "\00a0";
  display: block;
  height: 16px;
  width: 16px;
  position: absolute;
  bottom: -7.5px;
  transform: rotate(47deg) skew(5deg);
  -moz-transform: rotate(47deg) skew(5deg);
  -ms-transform: rotate(47deg) skew(5deg);
  -o-transform: rotate(47deg) skew(5deg);
  -webkit-transform: rotate(47deg) skew(5deg);
  box-shadow: 2px 2px 2px 0 rgba( 178, 178, 178, .4 );
  animation: fadeIn 6s linear;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  86% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.staticButton:hover {
  background-color: #4391CF;
  color: #FFFFFF;
}

.userInput {
  min-height: 45px;
  border-radius: 7px;
  border: 1px solid #a0a0a0;
  font-size: 12px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
  width: calc(100% - 30px);
}

.footer {
  margin-right: 20px;
  margin-left: 20px;
}

.footerBlurb {
  font-size: 10px;
  color: #a0a0a0;
  margin-top: 5px;
  margin-bottom: 5px;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}

.poweredBlurb {
  padding-top: 5px;
  padding-right: 5px;
  bottom: 10px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.table {
  font-family: "Arial";
  font-size: 12px;
  margin-bottom: 0px;
}

.table>tbody>tr>td,
.table>tbody>tr>th {
  border-top: none;
}

li {
  list-style: none;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.userMessage {
  background-color: #4391CF;
  color: #FFFFFF;
  border-radius: 7px;
  font-family: "Arial";
  font-size: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
  word-wrap: break-word;
  margin-left: 30px;
}

.botMessage {
  background-color: #f7f6f6;
  color: #414243;
  border-radius: 7px;
  font-family: "Arial";
  font-size: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
  word-wrap: break-word;
  margin-right: 30px;
}

.buttonMessage {
  background-color: #FFFFFF;
  font-size: 12px;
  font-family: "Arial";
  word-wrap: break-word;
  text-align: right;
  color: #4391CF;
}

.userBlurb {
  color: #a0a0a0;
  font-size: 10px;
  text-align: right;
  background-color: white;
}

.buttonBlurb {
  color: #a0a0a0;
  font-size: 10px;
  text-align: right;
  background-color: white;
}

.botBlurb {
  color: #a0a0a0;
  font-size: 10px;
  text-align: left;
  background-color: white;
}

.message-list-item {
  display: inline-block;
  margin-right: 10px;
}
.message-list-enter-active, .message-list-leave-active, .message-list-appear {
  transition: all 1.0s;
}
.message-list-enter, .message-list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.dotHolder {
  text-align: center;
}

.dot1 {
  height: 12px;
  width: 12px;
  display: inline-block;
  background-color: #939393;
  border-radius: 50%;
  -webkit-animation: typing 1.3s infinite;
  -webkit-animation-delay: 0.0s;
  animation: typing 1.3s infinite;
  animation-delay: 0.0s;
}

.dot2 {
  height: 12px;
  width: 12px;
  background-color: #939393;
  border-radius: 50%;
  display: inline-block;
  -webkit-animation: typing 1.3s infinite;
  -webkit-animation-delay: 0.2s;
  animation: typing 1.3s infinite;
  animation-delay: 0.2s;
}

.dot3 {
  height: 12px;
  width: 12px;
  background-color: #939393;
  border-radius: 50%;
  display: inline-block;
  -webkit-animation: typing 1.3s infinite;
  -webkit-animation-delay: 0.3s;
  animation: typing 1.3s infinite;
  animation-delay: 0.3s;
}

@-webkit-keyframes typing {
  0% { opacity: 0; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes typing {
  0% { opacity: 0; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

.link {
  color: #a0a0a0;;
}

.msgBot {
  text-align: left;
  padding: 0;
  margin: 0;
}

.msgUser {
  text-align: right;
  padding: 0;
  margin: 0;
}

.msgButton {
  text-align: right;
  padding: 0;
  margin: 0;
}

.buttonHolder {
  display: inline-block;
  text-align: center;
  padding-top: 10px;
}

.choice {
  color: #414243;
  border-radius: 30px;
  padding: 5px 20px;
  border: 1px solid #414243;
  cursor: pointer;
  margin-left: 2px;
  margin-right: 2px;
  background-color: #f7f6f6;
}

.choice:hover {
  background-color: #dedddd;
}
</style>



// WEBPACK FOOTER //
// src/components/Bot.vue